<template>
    <el-dialog
        title="绑定零担订单号"
        width="25%"
        :visible.sync="bindDialogVisible"
        :before-close="handleClose"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="form">
            <el-form-item prop="lclNo" label="零担运单号:">
                <el-input v-model="form.lclNo" maxlength="255"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { bindLclNo } from '@/modules/transport/otp/api/performanceWaybillManage';
export default {
    name: 'BindWaybill',
    props: {
        bindDialogVisible: {
            type: Boolean
        },
        selectedData: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            btnLoading: false,
            form: {
                lclNo: 0
            },
            rules: {
                lclNo: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value === null) {
                                callback(new Error('零担运单号不能为空'));
                            } else if (value === this.selectedData[0].lclNo) {
                                callback(new Error('请修改后再保存'));
                            } else if (!/^[0-9a-zA-Z]*$/.test(value)) {
                                callback(new Error('请输入正确的零担运单号'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            visible: false
        };
    },
    mounted () {
        this.form.lclNo = this.selectedData[0].lclNo;
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        handleSubmit () {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const taskNos = this.selectedData.map(v => v.taskNo);
                const params = {
                    taskNos,
                    lclNo: this.form.lclNo
                };
                this.btnLoading = true;
                bindLclNo(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('保存成功');
                        this.handleClose();
                    }
                }).finally(() => {
                    this.btnLoading = false;
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
.form {
    .el-input {
        width: 90%;
    }
}
</style>
